import { useAutomationExecution } from 'Automations/hooks/useAutomationExecution'
import { useParams } from 'react-router-dom'
import { useMemo } from 'react'

const LEGACY_PREFIX = 'legacy-'

export const useSelectedAutomationExecution = () => {
  const { executionId } = useParams<{ executionId: string }>()

  const { isLegacyExecution, legacyWorkflowId } = useMemo(() => {
    const isLegacy = executionId?.startsWith(LEGACY_PREFIX) ?? false
    return {
      isLegacyExecution: isLegacy,
      legacyWorkflowId: isLegacy
        ? (executionId?.slice(LEGACY_PREFIX.length) ?? null)
        : null
    }
  }, [executionId])

  const {
    automationExecution: selectedAutomationExecution,
    isPending,
    triggerType
  } = useAutomationExecution({
    executionId: isLegacyExecution ? null : (executionId ?? null)
  })

  return {
    isPending,
    triggerType,
    selectedAutomationExecution,
    isLegacyExecution,
    legacyWorkflowId
  }
}
